import React from 'react';

class SocialIcons extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            facebookUrl: "https://www.facebook.com/sharer/sharer.php?u=",
            twitterUrl: "https://twitter.com/intent/tweet?text=" + this.props.dealerName + "&url=",
            // instagramUrl : "https://www.facebook.com/sharer/sharer.php?u=",
            pinterestUrl: "https://pinterest.com/pin/create/button/?url=",
            linkedinUrl: "https://www.linkedin.com/shareArticle?mini=true&url=",
            // googleUrl : "https://plus.google.com/share?url="
        }
        this.handleOpenWin = this.handleOpenWin.bind(this);
        this.handleOpenModal = this.handleOpenModal.bind(this);
    }

    handleOpenWin(event) {
        event.preventDefault();
        let href = event.target;
        let link = href.getAttribute('rel');
        window.open(link, 'mywin', 'left=355,top=200,width=600,height=368,toolbar=1,resizable=0'); return false;
    }

    handleOpenModal(event) {
        if ((!!navigator.platform) && (/iPad|iPhone|iPod/.test(navigator.platform))) document.body.classList.add("ios-device");
    }

    render() {
        let iconStyles = null;
        let iconLinkColor = null;
        let fbStyle = null;
        let twitterStyle = null;
        let pinterestStyle = null;
        let linkedinStyle = null;
        // let googleStyle = null;
        let emailStyle = null;
        let icons = null;
        let id = null;

        if (this.props.template === "CROSSBAR") {
            id = "id23";
        } else if (this.props.template === "CROSSBAR_LEFT") {
            id = "id25";
        }

        if (this.props.template === "CROSSBAR" || this.props.template === "CROSSBAR_LEFT") {
            iconStyles = {
                marginTop: "1rem",
                fontSize: "22px",
                position: "relative"
            }

            if (this.props.template === "CROSSBAR_LEFT_FOOTER") {
                iconStyles.float = "right";
            }

            iconLinkColor = {
                color: "#FFF"
            }

            fbStyle = {
                backgroundColor: "rgb(66, 139, 202)",
                border: "1px solid rgb(66, 139, 202)",
                fontSize: "inherit"
            }

            // twitterStyle = {
            //     backgroundColor: "rgb(57, 179, 215)",
            //     border: "1px solid rgb(57, 179, 215)",
            //     fontSize: "inherit"
            // }

            twitterStyle = {
                backgroundColor: "#000000",
                border: "1px solid #000000",
                fontSize: "inherit"
            }

            pinterestStyle = {
                backgroundColor: "#E60023",
                border: "1px solid #E60023",
                fontSize: "inherit"
            }

            linkedinStyle = {
                backgroundColor: "#0077B5",
                border: "1px solid #0077B5",
                fontSize: "inherit"
            }


            // googleStyle = {
            //     backgroundColor : "rgb(237, 156, 40)",
            //     border : "1px solid rgb(237, 156, 40)",
            //     fontSize : "inherit"
            // }
            emailStyle = {
                backgroundColor: "rgb(71, 164, 71)",
                border: "1px solid rgb(71, 164, 71)",
                fontSize: "inherit"
            }

            const combinedStyles = {
                ...iconStyles,
                border: "1px solid #F2F0EF",
                backgroundColor: "#F2F0EF",
                padding: "8px",
                borderRadius: "8px",
                display: "inline-flex",
                flexDirection: "column"
            }

            const socialMediaSharing = {
                fontSize: "14px",
                fontFamily: "sans-serif",
                textTransform: "capitalize",
                padding: "0 0 2px 8px !important",
                display: "block"
            }

            icons = <div id={id} style={combinedStyles} className="btn-group" role="group" aria-label="social icons" >
                <div style={socialMediaSharing} class=" btn-group">Share On</div>
                <div style={{ display: "flex" }}>
                    <button type="button" style={fbStyle} className="btn btn-primary temp-17" onClick={this.handleOpenWin} rel={this.state.facebookUrl + this.props.shareurl}>
                        <a style={iconLinkColor} href={this.state.facebookUrl + this.props.shareurl} > <i rel={this.state.facebookUrl + this.props.shareurl} className="fa-brands fa-facebook-f"></i></a>
                    </button>
                    <button type="button" style={twitterStyle} className="btn btn-primary temp-17" onClick={this.handleOpenWin} rel={this.state.twitterUrl + this.props.shareurl}>
                        <a style={iconLinkColor} href={this.state.twitterUrl + this.props.shareurl}> <i rel={this.state.twitterUrl + this.props.shareurl} className="fab fa-x-twitter"></i></a>
                    </button>

                    <button type="button" style={pinterestStyle} className="btn btn-primary temp-17" onClick={this.handleOpenWin} rel={this.state.pinterestUrl + this.props.shareurl}>
                        <a style={iconLinkColor} href={this.state.pinterestUrl + this.props.shareurl} > <i rel={this.state.pinterestUrl + this.props.shareurl} className="fa-brands fa-pinterest"></i></a>
                    </button>

                    <button type="button" style={linkedinStyle} className="btn btn-primary temp-17" onClick={this.handleOpenWin} rel={this.state.linkedinUrl + this.props.shareurl}>
                        <a style={iconLinkColor} href={this.state.linkedinUrl + encodeURIComponent(this.props.shareurl)} > <i rel={this.state.linkedinUrl + encodeURIComponent(this.props.shareurl)} className="fa-brands fa-linkedin"></i></a>
                    </button>
                    {/*<button type="button" style={googleStyle} className="btn btn-primary temp-17" onClick={this.handleOpenWin} rel={this.state.googleUrl+this.props.shareurl}>*/}
                    {/*<a style={iconLinkColor} href={this.state.googleUrl+this.props.shareurl}> <i rel={this.state.googleUrl+this.props.shareurl} className="fa fa-google"></i></a>*/}
                    {/*</button>*/}
                    <button
                        type="button"
                        style={emailStyle}
                        className="btn btn-primary temp-17"
                        onClick={this.handleOpenModal}
                        data-toggle="modal"
                        data-target="#carModal">
                        <a style={iconLinkColor} href="#0"> <i className="fa-solid fa-envelope"></i></a>
                    </button>
                </div>
            </div>
        } else if (this.props.template === "CROSSBAR_FOOTER" || this.props.template === "CROSSBAR_LEFT_FOOTER") {
            const iconLinkColorFb = {
                color: (typeof this.props.checkTheme !== 'undefined') ? "#FFFFF7" : "#3b5998",
                fontSize: '18px',
                padding: '3px'
            }

            const iconLinkColorTwitter = {
                color: (typeof this.props.checkTheme !== 'undefined') ? "#FFFFF7" : "#00aced",
                fontSize: '18px',
                padding: '3px'
            }

            const iconLinkColorGplus = {
                color: (typeof this.props.checkTheme !== 'undefined') ? "#FFFFF7" : "#dd4b39",
                fontSize: '18px',
                padding: '3px'
            }

            const iconLinkColorPinterest = {
                color: (typeof this.props.checkTheme !== 'undefined') ? "#FFFFF7" : "#000",
                fontSize: '18px',
                padding: '3px'
            }

            const iconLinkColorLinkedin = {
                color: (typeof this.props.checkTheme !== 'undefined') ? "#FFFFF7" : "#dd4b39",
                fontSize: '18px',
                padding: '3px'
            }

            const iconLinkColorEmail = {
                color: (typeof this.props.checkTheme !== 'undefined') ? "#FFFFF7" : "#000",
                fontSize: '18px',
                padding: '3px'
            }

            const combinedStyles = {
                ...iconStyles,
                border: "1px solid #F2F0EF",
                backgroundColor: "#F2F0EF",
                padding: "8px",
                borderRadius: "8px",
            }

            const socialMediaSharing = {
                fontSize: "14px",
                fontFamily: "sans-serif",
                textTransform: "capitalize",
                padding: "0 0 2px 8px !important",
                display: "block",
                marginLeft: "10px"
            }

            icons = <div style={combinedStyles} className="float-left" role="group" aria-label="social icons">
                <div style={socialMediaSharing} class=" btn-group">Share On</div>
                <a style={iconLinkColorFb} href={this.state.facebookUrl + this.props.shareurl} onClick={this.handleOpenWin}> <i rel={this.state.facebookUrl + this.props.shareurl} className="fa-brands fa-facebook-f"></i></a>
                <a style={iconLinkColorTwitter} href={this.state.twitterUrl + this.props.shareurl} onClick={this.handleOpenWin}> <i rel={this.state.twitterUrl + this.props.shareurl} className="fab fa-x-twitter"></i></a>

                <a style={iconLinkColorPinterest} href={this.state.pinterestUrl + this.props.shareurl} onClick={this.handleOpenWin}> <i rel={this.state.pinterestUrl + this.props.shareurl} className="fa-brands fa-pinterest"></i></a>

                <a style={iconLinkColorLinkedin} href={this.state.linkedinUrl + encodeURIComponent(this.props.shareurl)} onClick={this.handleOpenWin}> <i rel={this.state.linkedinUrl + encodeURIComponent(this.props.shareurl)} className="fa-brands fa-linkedin"></i></a>
                {/*<a style={iconLinkColorGplus} href={this.state.googleUrl+this.props.shareurl} onClick={this.handleOpenWin}> <i rel={this.state.googleUrl+this.props.shareurl} className="fa fa-google"></i></a>*/}
                <a style={iconLinkColorEmail}
                    href="#0"
                    onClick={this.handleOpenModal}
                    data-toggle="modal"
                    data-target="#carModal"> <i rel={this.props.shareurl} className="far fa-envelope"></i></a>
            </div>

        } else if (this.props.template === "GET_STARTED" ||
            this.props.template === "GET_STARTED_FOOTER" ||
            this.props.template === "LINKED_UP" ||
            this.props.template === "LINKED_UP_FOOTER" ||
            this.props.template === "SIMPLE_FLICKS" ||
            this.props.template === "LINKED_UP_LEFT" ||
            this.props.template === "LINKED_UP_LEFT_FOOTER" ||
            this.props.template === "LP_LINKS_WITH_ICONS") {
            iconStyles = {
                marginTop: "0",
                fontSize: "20px",
                float: "right"
            }

            iconLinkColor = {
                color: "#C4C6C9"
            }

            if (this.props.template === "LINKED_UP" ||
                this.props.template === "LINKED_UP_LEFT" ||
                this.props.template === "LINKED_UP_FOOTER" ||
                this.props.template === "LINKED_UP_LEFT_FOOTER" ||
                this.props.template === "LP_LINKS_WITH_ICONS"
            ) {
                iconLinkColor = {
                    color: "#FFF"
                }
            }

            fbStyle = {
                backgroundColor: "transparent",
                border: "1px solid transparent",
                fontSize: "inherit"
            }

            twitterStyle = {
                backgroundColor: "transparent",
                border: "1px solid transparent",
                fontSize: "inherit"
            }

            pinterestStyle = {
                backgroundColor: "transparent",
                border: "1px solid transparent",
                fontSize: "inherit"
            }

            linkedinStyle = {
                backgroundColor: "transparent",
                border: "1px solid transparent",
                fontSize: "inherit"
            }

            // googleStyle = {
            //     backgroundColor : "transparent",
            //     border : "1px solid transparent",
            //     fontSize : "inherit"
            // }
            emailStyle = {
                backgroundColor: "transparent",
                border: "1px solid transparent",
                fontSize: "inherit"
            }

            let combinedStyles = {
                ...iconStyles,
                border: "1px solid rgb(242 240 239 / 14%)",
                backgroundColor: "rgb(242 240 239 / 14%)",
                borderRadius: "8px",
                display: "inline-flex",
                flexDirection: "column",
                // marginBottom: "10px",
            }

            let socialMediaSharing = {
                fontSize: "14px",
                fontFamily: "sans-serif",
                textTransform: "capitalize",
                padding: "0 0 2px 8px !important",
                display: "block",
                marginLeft: "10px"
            }

            if(this.props.template === "GET_STARTED" || this.props.template === "GET_STARTED_FOOTER" || this.props.template === "SIMPLE_FLICKS"){
                combinedStyles = {
                    ...iconStyles,
                    border: "1px solid rgb(242 240 239 / 14%)",
                    backgroundColor: "rgb(242 240 239 / 14%)",
                    borderRadius: "8px",
                    display: "inline-flex",
                    flexDirection: "column",
                    margin: "10px auto",
                    width:"100%",
                }
            }

            if (this.props.template === "LP_LINKS_WITH_ICONS") {
                let iconLinks = null;
                if (this.props.iconLinks != "") {
                    iconLinks = this.props.iconLinks.map((image) => {
                        if (image.custom_button) {
                            return <a className="btn temp-17" href={image.link} target="_blank"><img style={{ maxHeight: "30px" }} src={image.icon_url} /></a>
                        }
                    });
                }
                icons = <div id={id} style={iconStyles} className="btn-group" role="group" aria-label="social icons">{iconLinks}</div>
            } else {
                icons = <div id={id} style={combinedStyles} className="btn-group" role="group" aria-label="social icons">
                    <div style={socialMediaSharing} class=" btn-group">Share On</div>
                    <div style={{ display: "flex" }}>
                        <button type="button" style={fbStyle} className="btn btn-primary temp-17" onClick={this.handleOpenWin} rel={this.state.facebookUrl + this.props.shareurl}>
                            <a style={iconLinkColor} onClick={this.handleOpenWin} href={this.state.facebookUrl + this.props.shareurl}> <i rel={this.state.facebookUrl + this.props.shareurl} className="fa-brands fa-facebook-f"></i></a>
                        </button>
                        <button type="button" style={twitterStyle} className="btn btn-primary temp-17" onClick={this.handleOpenWin} rel={this.state.twitterUrl + this.props.shareurl}>
                            <a style={iconLinkColor} href={this.state.twitterUrl + this.props.shareurl} onClick={this.handleOpenWin}> <i rel={this.state.twitterUrl + this.props.shareurl} className="fab fa-x-twitter"></i></a>
                        </button>

                        <button type="button" style={pinterestStyle} className="btn btn-primary temp-17" onClick={this.handleOpenWin} rel={this.state.pinterestUrl + this.props.shareurl}>
                            <a style={iconLinkColor} href={this.state.pinterestUrl + this.props.shareurl} onClick={this.handleOpenWin}> <i rel={this.state.pinterestUrl + this.props.shareurl} className="fa-brands fa-pinterest"></i></a>
                        </button>

                        <button type="button" style={linkedinStyle} className="btn btn-primary temp-17" onClick={this.handleOpenWin} rel={this.state.linkedinUrl + this.props.shareurl}>
                            <a style={iconLinkColor} href={this.state.linkedinUrl + encodeURIComponent(this.props.shareurl)} onClick={this.handleOpenWin}> <i rel={this.state.linkedinUrl + encodeURIComponent(this.props.shareurl)} className="fa-brands fa-linkedin"></i></a>
                        </button>
                        {/*<button type="button" style={googleStyle} className="btn btn-primary temp-17"  onClick={this.handleOpenWin} rel={this.state.googleUrl+this.props.shareurl}>*/}
                        {/*<a style={iconLinkColor} href={this.state.googleUrl+this.props.shareurl} onClick={this.handleOpenWin}> <i rel={this.state.googleUrl+this.props.shareurl} className="fa fa-google"></i></a>*/}
                        {/*</button>*/}
                        <button type="button"
                            style={emailStyle}
                            className="btn btn-primary temp-17"
                            onClick={this.handleOpenModal}
                            data-toggle="modal"
                            data-target="#carModal" rel={this.props.shareurl}>
                            <a style={iconLinkColor} href="#0"> <i className="fa-solid fa-envelope"></i></a>
                        </button>
                    </div>
                </div>
            }

        } else if (this.props.template === "SOCIALIZE" || this.props.template === "SOCIALIZE_FOOTER") {
            iconStyles = {
                marginTop: "0",
                fontSize: "20px",
                float: "right"
            }

            const combinedStyles = {
                ...iconStyles,
                border: "1px solid #F2F0EF",
                backgroundColor: "#F2F0EF",
                borderRadius: "8px",
                display: "inline-flex",
                flexDirection: "column",
                margin: "14px auto",
                padding: "unset !important",
                float:"unset !important",
                width:"100%"
            }

            const socialMediaSharing = {
                fontSize: "14px",
                fontFamily: "sans-serif",
                textTransform: "capitalize",
                marginLeft: "24px",
                padding: "2px 0",
            }

            icons = <div className="col-md-12">
                <div id={id} style={combinedStyles} className="btn-group" role="group" aria-label="social icons">
                    <div style={socialMediaSharing} class="btn-group">Share On</div>
                    <div style={{display:'flex',justifyContent:"space-evenly"}}>
                        <span style={fbStyle} onClick={this.handleOpenWin} rel={this.state.facebookUrl + this.props.shareurl}>
                            <a onClick={this.handleOpenWin} href={this.state.facebookUrl + this.props.shareurl}> <i rel={this.state.facebookUrl + this.props.shareurl} className="icon-facebook"></i></a>
                        </span>

                        <span style={twitterStyle} onClick={this.handleOpenWin} rel={this.state.twitterUrl + this.props.shareurl}>
                            <a href={this.state.twitterUrl + this.props.shareurl} onClick={this.handleOpenWin}> <i rel={this.state.twitterUrl + this.props.shareurl} className="icon-twitter"></i></a>
                        </span>

                        <span style={pinterestStyle} onClick={this.handleOpenWin} rel={this.state.pinterestUrl + this.props.shareurl}>
                            <a href={this.state.pinterestUrl + this.props.shareurl} onClick={this.handleOpenWin}> <i rel={this.state.pinterestUrl + this.props.shareurl} className="icon-pinterest"></i></a>
                        </span>

                        <span style={linkedinStyle} onClick={this.handleOpenWin} rel={this.state.linkedinUrl + this.props.shareurl}>
                            <a href={this.state.linkedinUrl + encodeURIComponent(this.props.shareurl)} onClick={this.handleOpenWin}> <i rel={this.state.linkedinUrl + encodeURIComponent(this.props.shareurl)} className="icon-linkedin"></i></a>
                        </span>
                        {/*<span style={googleStyle}  onClick={this.handleOpenWin} rel={this.state.googleUrl+this.props.shareurl}>*/}
                        {/*<a  href={this.state.googleUrl+this.props.shareurl} onClick={this.handleOpenWin}> <i rel={this.state.googleUrl+this.props.shareurl} className="icon-google"></i></a>*/}
                        {/*</span>*/}
                        <span style={emailStyle}
                            onClick={this.handleOpenModal}
                            data-toggle="modal"
                            data-target="#carModal"
                            rel={this.props.shareurl}>
                            <a href="#0"> <i className="icon-envelope"></i></a>
                        </span>
                    </div>
                </div>
            </div>
        } else if (this.props.template === "THEATER"
            || this.props.template === "THEATER_CONTACT"
            || this.props.template === "THEATER_CONTACT_FOOTER"
            || this.props.template === "THEATER_FOOTER"
            || this.props.template === "NEWSLETTER"
            || this.props.template === "NEWSLETTER_FOOTER"
            || this.props.template === "TABBED_THEATER"
            || this.props.template === "TABBED_THEATER_FOOTER"
            || this.props.template === "THEATER_360_FOOTER") {
            const iconLinkColorFb = {
                color: (typeof this.props.checkTheme.backgroundImage !== 'undefined') ? "#FFFFF7" : "#3b5998",
                fontSize: '18px',
                padding: '3px'
            }

            const iconLinkColorTwitter = {
                color: (typeof this.props.checkTheme.backgroundImage !== 'undefined') ? "#FFFFF7" : "#00aced",
                fontSize: '18px',
                padding: '3px'
            }

            const iconLinkColorPinterest = {
                color: (typeof this.props.checkTheme.backgroundImage !== 'undefined') ? "#FFFFF7" : "#00aced",
                fontSize: '18px',
                padding: '3px'
            }

            const iconLinkColorLinkedin = {
                color: (typeof this.props.checkTheme.backgroundImage !== 'undefined') ? "#FFFFF7" : "#00aced",
                fontSize: '18px',
                padding: '3px'
            }

            const iconLinkColorGplus = {
                color: (typeof this.props.checkTheme.backgroundImage !== 'undefined') ? "#FFFFF7" : "#dd4b39",
                fontSize: '18px',
                padding: '3px'
            }

            const iconLinkColorEmail = {
                color: (typeof this.props.checkTheme.backgroundImage !== 'undefined') ? "#FFFFF7" : "#000",
                fontSize: '18px',
                padding: '3px'
            }

            const combinedStyles = {
                ...iconStyles,
                border: "1px solid #F2F0EF",
                backgroundColor: "#F2F0EF",
                padding: "3px",
                borderRadius: "8px",
            }

            const socialMediaSharing = {
                fontSize: "14px",
                fontFamily: "sans-serif",
                textTransform: "capitalize",
                padding: "0 0 2px 8px !important",
                display: "block",
                marginLeft:"10px"
            }

            icons = <div style={combinedStyles} className="float-left" role="group" aria-label="social icons">
                <div class="btn-group" style={socialMediaSharing}>Share On</div>
                <a style={iconLinkColorFb} href={this.state.facebookUrl + this.props.shareurl} onClick={this.handleOpenWin}> <i rel={this.state.facebookUrl + this.props.shareurl} className="fa-brands fa-facebook-f"></i></a>
                <a style={iconLinkColorTwitter} href={this.state.twitterUrl + this.props.shareurl} onClick={this.handleOpenWin}> <i rel={this.state.twitterUrl + this.props.shareurl} className="fab fa-x-twitter"></i></a>

                <a style={iconLinkColorPinterest} href={this.state.pinterestUrl + this.props.shareurl} onClick={this.handleOpenWin}> <i rel={this.state.pinterestUrl + this.props.shareurl} className="fa-brands fa-pinterest"></i></a>

                <a style={iconLinkColorLinkedin} href={this.state.linkedinUrl + encodeURIComponent(this.props.shareurl)} onClick={this.handleOpenWin}> <i rel={this.state.linkedinUrl + encodeURIComponent(this.props.shareurl)} className="fa-brands fa-linkedin"></i></a>
                {/*<a style={iconLinkColorGplus} href={this.state.googleUrl+this.props.shareurl} onClick={this.handleOpenWin}> <i rel={this.state.googleUrl+this.props.shareurl} className="fa fa-google"></i></a>*/}
                <a style={iconLinkColorEmail}
                    href="#0"
                    onClick={this.handleOpenModal}
                    data-toggle="modal"
                    data-target="#carModal"> <i rel={this.props.shareurl} className="far fa-envelope"></i></a>
            </div>
        }
        return icons;
    }
}
export default SocialIcons;


// WEBPACK FOOTER //
// ./src/components/SocialIcons.js